export const isMicrosoftLoginEnabled = () =>
  process.env.REACT_APP_ENABLE_MICROSOFT_LOGIN === 'true';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'common'}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || `${window.location.origin}/v2/login`,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || `${window.location.origin}/v2/login`,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: (process.env.REACT_APP_AZURE_LOGIN_SCOPE || 'openid profile email').split(' '),
};
